import { deprecatedColorThemeConfig } from './deprecatedColors';
const primary = 'Figs, Raleway, sans-serif';
const editorial = 'freight-big-pro';
const { black } = deprecatedColorThemeConfig;
export const deprecatedTextThemeConfig = {
    h1: {
        primary: {
            color: black.primary,
            fontFamily: primary,
            device: {
                small: {
                    fontSize: '28px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    lineHeight: '24px',
                },
                medium: {
                    fontSize: '28px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    lineHeight: '24px',
                },
                large: {
                    fontSize: '28px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    lineHeight: '36px',
                },
            },
        },
        editorial: {
            color: black.primary,
            fontFamily: editorial,
            device: {
                small: {
                    fontSize: '30px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '30px',
                },
                medium: {
                    fontSize: '30px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '30px',
                },
                large: {
                    fontSize: '30px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '30px',
                },
            },
        },
    },
    h2: {
        primary: {
            color: black.primary,
            fontFamily: primary,
            device: {
                small: {
                    fontSize: '18px',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    lineHeight: '24px',
                },
                medium: {
                    fontSize: '18px',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    lineHeight: '24px',
                },
                large: {
                    fontSize: '16px',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    lineHeight: '26px',
                },
            },
        },
        editorial: {
            color: black.primary,
            fontFamily: editorial,
            device: {
                small: {
                    fontSize: '18px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '24px',
                },
                medium: {
                    fontSize: '18px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '24px',
                },
                large: {
                    fontSize: '18px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '24px',
                },
            },
        },
    },
    subhead: {
        primary: {
            color: black.primary,
            fontFamily: primary,
            device: {
                small: {
                    fontSize: '16px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '26px',
                },
                medium: {
                    fontSize: '16px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '26px',
                },
                large: {
                    fontSize: '16px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '26px',
                },
            },
        },
        editorial: {
            color: black.primary,
            fontFamily: editorial,
            device: {
                small: {
                    fontSize: '16px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '26px',
                },
                medium: {
                    fontSize: '16px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '26px',
                },
                large: {
                    fontSize: '16px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '26px',
                },
            },
        },
    },
    paragraph: {
        primary: {
            color: black.primary,
            fontFamily: primary,
            device: {
                small: {
                    fontSize: '13px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '20px',
                },
                medium: {
                    fontSize: '13px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '20px',
                },
                large: {
                    fontSize: '13px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '20px',
                },
            },
        },
        editorial: {
            color: black.primary,
            fontFamily: editorial,
            device: {
                small: {
                    fontSize: '13px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '20px',
                },
                medium: {
                    fontSize: '13px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '20px',
                },
                large: {
                    fontSize: '13px',
                    fontWeight: 400,
                    letterSpacing: '0.6px',
                    lineHeight: '20px',
                },
            },
        },
    },
    tag: {
        primary: {
            color: black.primary,
            fontFamily: primary,
            device: {
                small: {
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    lineHeight: '11px',
                },
                medium: {
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    lineHeight: '11px',
                },
                large: {
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    lineHeight: '11px',
                },
            },
        },
        editorial: {
            color: black.primary,
            fontFamily: editorial,
            device: {
                small: {
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    lineHeight: '11px',
                },
                medium: {
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    lineHeight: '11px',
                },
                large: {
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    lineHeight: '11px',
                },
            },
        },
    },
};
//# sourceMappingURL=deprecatedText.js.map